import {createActions, handleActions, combineActions} from 'redux-actions';
import actions from './session.actions';

const reducer = handleActions(
	{
		[actions.sessionLoginSuccess]: (state, {payload}) => ({
			...state,
			current: {...payload},
			status: 'authenticated'
		}),
		[actions.sessionSetSocketCleanup]: (state, {payload}) => ({
			...state,
			socketCleanup: payload
		}),
		[actions.sessionLoginError]: state => ({
			...state,
			current: null,
			status: 'error'
		}),
		[actions.sessionLoginExpired]: state => ({
			...state,
			current: null,
			status: 'expired'
		}),
		[actions.sessionLogoutSuccess]: state => ({
			...state,
			current: null,
			status: null
		}),
		[actions.sessionLoginWaiting]: state => ({
			...state,
			current: null,
			status: 'waiting'
		}),
		[actions.sessionUpdateUniqueName]: (state, {payload}) =>
			state.current
				? {
						...state,
						current: {
							...state.current,
							provider: {
								...state.current.provider,
								profile: {
									...state.current.provider.profile,
									uniqueName: payload
								}
							}
						}
				  }
				: state,
		[actions.sessionUpdateMembershipLimit]: (state, {payload}) =>
			state.current
				? {
						...state,
						current: {
							...state.current,
							user: {
								...state.current.user,
								exceededMembershipLimit: payload
							}
						}
				  }
				: state,
		[actions.sessionUpdateSubscriptionLevel]: (state, {payload}) =>
			state.current
				? {
						...state,
						current: {
							...state.current,
							provider: {
								...state.current.provider,
								subscriptionLevel: payload
							}
						}
				  }
				: state,
		[actions.sessionUpdateAvatarImage]: (state, {payload}) =>
			state.current
				? {
						...state,
						current: {
							...state.current,
							provider: {
								...state.current.provider,
								profile: {
									...state.current.provider.profile,
									avatarImage: payload
								}
							}
						}
				  }
				: state,
		[actions.sessionFavouritesRetrieving]: state => ({
			...state,
			favourites: null
		}),
		[actions.sessionFavouritesRetrieved]: (state, {payload}) => ({
			...state,
			favourites: payload.reduce((accum, uuid) => (accum[uuid] = true) && accum, {}) // List -> map
		}),
		[actions.sessionFavouriteSet]: (state, {payload}) => ({
			...state,
			favourites: {
				...state.favourites,
				[payload]: true
			}
		}),
		[actions.sessionFavouriteUnset]: (state, {payload}) => ({
			...state,
			favourites: {
				...state.favourites,
				[payload]: null
			}
		}),
		[actions.sessionUsernameChanged]: (state, {payload}) => ({
			...state,
			current: {
				...state.current,
				user: {
					...state.current.user,
					username: payload
				}
			}
		}),
		/**
		 * Awkward state syncing between profile <-> session user
		 */
		[actions.sessionUpdateCurrentProvider]: (state, {payload}) => ({
			...state,
			current: {
				...state.current,
				provider: payload
					? {
							...state.current.provider,
							...payload,
							user: payload.user
								? {
										...state.current.provider.user,
										...payload.user
								  }
								: state.current.provider.user,
							profile: payload.profile
								? {
										...state.current.provider.profile,
										...payload.profile
								  }
								: state.current.provider.profile
					  }
					: state.current.provider,
				// Yea, not really sure why user and provider are separate and duplicated :'(
				user:
					payload && payload.user
						? {
								...state.current.user,
								...payload.user
						  }
						: state.current.user
			}
		}),

		/**
		 * Unique name of community to sign-up with initially
		 */
		[actions.sessionSignupCommunity]: (state, {payload}) => ({
			...state,
			signupCommunity: payload
		}),

		/**
		 * Set a flag indicating user is viewing profile for the first time
		 **/
		[actions.sessionProfileFirstTime]: (state, {payload = true}) => ({
			...state,
			profileFirstTime: payload
		}),
		[actions.sessionAffiliationsLoaded]: (state, {payload}) => ({
			...state,
			communities: [...payload],
			affiliationsLoading: false
		}),
		[actions.sessionAffiliationsLoading]: (state, {payload}) => ({
			...state,
			affiliationsLoading: true
		}),
		[actions.sessionAffiliationsFailed]: (state, {payload}) => ({
			...state,
			affiliationsLoading: false
		})
	},
	{
		// Default
		current: null, // Current user/provider details
		favourites: null, // Current user/provider favourites
		status: null, // Authentication status (default: unauthenticated)
		signupCommunity: null,
		profileFirstTime: false
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/user/session.reducer.js